import {ITask} from "../../../../interfaces/ITask";
import React from "react";
import {enumNamesToSelect, MuiDatePickers, AdapterDateFns, Checkbox, FormControlLabel, FormHelperText, Box, TextField, Tooltip, Stack} from "@leap4/frontend";
import {CronExpression} from "../../../../helpers/enums";
import {TaskTypeSelect} from "./TaskTypeSelect";
import JSONInput from 'react-json-editor-ajrm';
// @ts-ignore
import locale from 'react-json-editor-ajrm/locale/en';

const {DateTimePicker, LocalizationProvider} = MuiDatePickers;

export interface IDetailsFormProps {
    task: ITask
    getTaskTypes: () => Promise<string[]>
    updateTask: (tag: ITask) => void
    mode: "create" | "edit"
}

const CronSelect = enumNamesToSelect(CronExpression)

const DetailsForm = (props: IDetailsFormProps) => {
    const {task, updateTask, getTaskTypes} = props;

    const onChange = (e: any) => {
        let {name, value} = e.target;
        updateTask({...task, [name]: value});
    }

    const onDateChange = (newDate: any) => {
        if (!newDate) return;
        const newDateAsTimestamp = new Date(newDate).getTime()
        updateTask({...task, nextRun: newDateAsTimestamp})
    }

    const onChangeParams = (obj: any) => {
        if (obj.error) {
            return;
        }

        const values = JSON.parse(obj.json)
        updateTask({...task, params: values})
    }

    return (
        <>

            {props.mode === "edit" && (
                <Box mb={2}>
                    <TextField
                        fullWidth
                        required
                        value={props.task._id}
                        disabled
                        size="small"
                        label="ID"
                        variant="standard"
                    />
                </Box>
            )}

            <Box mb={2}>
                <FormHelperText>
                    <b>Name</b>
                </FormHelperText>
                <TextField
                    value={task.name}
                    onChange={onChange}
                    size="small"
                    fullWidth
                    variant="outlined"
                    name="name"
                />
            </Box>

            <TaskTypeSelect
                currentValue={task.type || ""}
                getTypes={getTaskTypes}
                onUpdate={(value: string) => updateTask({...task, "type": value})
                }/>

            <Box mb={2}>
                <FormHelperText>
                    <b>Description</b>
                </FormHelperText>
                <TextField
                    onChange={onChange}
                    multiline
                    rows={3}
                    size="small"
                    variant="outlined"
                    name="description"
                    value={task.description}
                    fullWidth
                />
            </Box>
            <Tooltip title={`Params should be JSON`} placement={"top-start"} arrow>
                <Box mb={2}>
                    <FormHelperText>
                        <b>Parameters</b>
                    </FormHelperText>
                    <JSONInput
                        height={"10%"}
                        locale={locale}
                        colors={{background: "white", string: "black", default: "black", keys: "black",}}
                        placeholder={task.params}
                        onChange={onChangeParams}
                    />
                </Box>
            </Tooltip>
            <Box mb={2}>
                <FormHelperText>
                    <b>Run Frequency</b>
                </FormHelperText>
                <Stack direction="row" spacing={1}>
                    <Box flex={1}>
                        <CronSelect
                            required
                            fullWidth
                            value={task.cronExpression}
                            onChange={onChange}
                            name="cronExpression"/>
                    </Box>
                    <Box flex={1}>
                        <TextField value={task.cronExpression} fullWidth
                                   onChange={({target}) => updateTask({...task, cronExpression: target.value})}/>
                    </Box>
                </Stack>
            </Box>
            <Stack direction="row" spacing={2} justifyContent='space-between' alignItems='center'>
                {props.mode === "edit" && (
                    <Box sx={{width: '85%'}}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <FormHelperText>
                                <b>Start at (NEXT RUN)</b>
                            </FormHelperText>
                            <DateTimePicker
                                minDateTime={new Date()}
                                value={task.nextRun ? new Date(task.nextRun) : null}
                                onChange={(newValue: Date | null) => onDateChange(newValue)}
                                slotProps={{ textField: { fullWidth: true } }}
                            />
                        </LocalizationProvider>

                    </Box>
                )}
                <Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                defaultChecked={task.isActive}
                                value={task.isActive}
                                onChange={onChange}
                                name="isActive"
                            />
                        }
                        label="Is Active"
                    />
                </Box>

            </Stack>
        </>
    )
}

export {DetailsForm}
